import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserService } from '../../shared/providers/user.service';
import { UserPermissionResponse } from '../../shared/model/response/user-permission-response';

@Injectable()
export class PermissionsResolver  {

  constructor(private userService: UserService,
              private permissionService: NgxPermissionsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<UserPermissionResponse> | Promise<UserPermissionResponse> | UserPermissionResponse {
    return new Observable((subscriber: Subscriber<UserPermissionResponse>) => {
      this.userService.getPermissions().subscribe(
        (permissions: UserPermissionResponse) => {
          // Load permissions
          this.permissionService.loadPermissions(permissions.permissions);

          subscriber.next(permissions);
          subscriber.complete();
        },
        (error: any) => {
          subscriber.error(error);
        }
      );
    });
  }

}
